import React, { useEffect } from 'react';
import Content from '../components/Content';
import GenericSnack from '../components/GenericSnack';
import MainAuthorsContent from '../components/main/authors/create/MainAuthorsContent';
import MainAuthorFormStore from '../stores/MainAuthorFormStore';
import { useNavigate, useParams } from 'react-router';
import { observer } from 'mobx-react';

const MainAuthorsUpdate = observer(({userStore, snackStore}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const mainAuthorFormStore = new MainAuthorFormStore(userStore, snackStore, navigate, false);

  useEffect(async () => {
    await mainAuthorFormStore.loadAuthor(id);
  });

  return (
    <Content title='Criar Novo Autor-pai' userStore={userStore}>
      <GenericSnack snackStore={snackStore} />
      <MainAuthorsContent mainAuthorsFormStore={mainAuthorFormStore} />
    </Content>
  );
});

export default MainAuthorsUpdate;
